import { IconButton, Stack, Typography } from "@mui/material"
import { darken, useTheme } from "@mui/material/styles"
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'

interface QuantityStepperProps {
    quantidade: number
    onAdd: () => void
    onRemove: () => void
    maxAtingido?: boolean
}

function QuantityStepper({ quantidade, onAdd, onRemove, maxAtingido = false }: QuantityStepperProps): JSX.Element {
    const theme = useTheme()

    return (
        <Stack direction="row" alignItems="center" spacing={1.5} sx={{ flexShrink: 0 }}>
            <IconButton
                onClick={onRemove}
                disabled={quantidade <= 0}
                aria-label="Remover uma unidade"
                sx={{ border: '1px solid', borderColor: 'divider', width: 48, height: 48 }}
            >
                <RemoveIcon />
            </IconButton>

            <Typography variant="h5" sx={{ fontWeight: 'bold', minWidth: 32, textAlign: 'center' }}>
                {quantidade}
            </Typography>

            <IconButton
                onClick={onAdd}
                disabled={maxAtingido}
                aria-label="Adicionar uma unidade"
                sx={{
                    width: 48,
                    height: 48,
                    color: 'primary.contrastText',
                    backgroundColor: 'primary.main',
                    '&:hover': { backgroundColor: darken(theme.palette.primary.main, 0.1) },
                    '&.Mui-disabled': { backgroundColor: 'action.disabledBackground', color: 'action.disabled' },
                }}
            >
                <AddIcon />
            </IconButton>
        </Stack>
    )
}

export default QuantityStepper